<script setup lang="ts">
import { useCoverImage } from '../../../composables/use-cover-image'

const { coverImageUrl } = useCoverImage()
</script>

<template>
  <div class="bx-footer__abo-teaser bx-form bx-typo--form">
    <div class="bx-footer__abo-teaser-image">
      <img :src="coverImageUrl('lecker', 180)"
           loading="lazy"
           width="180"
           height="147"
           data-pin-nopin="true"
           alt="Cover der aktuellen Lecker Ausgabe"
           title="Cover der aktuellen Lecker Ausgabe">
    </div>
    <div class="bx-footer__abo-teaser-inner-wrapper">
      <span class="bx-footer__abo-teaser-headline">
        LECKER Magazin
      </span>
      <span class="bx-footer__abo-teaser-roofline">
        Jeden Monat neu
      </span>
      <a class="bx-form__button"
         target="_blank"
         rel="noopener"
         href="https://www.bauer-plus.de/lecker/">
        Zum Abo
      </a>
    </div>
  </div>
</template>
